export default function getAllMatches(
  text: string,
  regExp: RegExp
): RegExpMatchArray[] {
  const regExpCopy = new RegExp(regExp);
  const result = [];
  let currentMatch = null;

  while ((currentMatch = regExpCopy.exec(text))) {
    result.push(currentMatch);
  }

  return result;
}
